import { useQuery, UseQueryResult } from "react-query";
import {
  getCrossMerchantTransferPath,
  getCrossMerchantTransferPathMerchantTab,
} from "../../../api/merchant";
import { useReduxContext } from "./reduxContext";
import { GetTableListRes } from "./config";

const useMerchantTabQuery = (): UseQueryResult<GetTableListRes> => {
  const [state] = useReduxContext();
  const { merchantTabParams, merchantTabRefetchCounter } = state;

  return useQuery({
    queryKey: [
      "getCrossMerchantTransferPathMerchantTab",
      merchantTabParams,
      merchantTabRefetchCounter,
    ],
    queryFn: () => getCrossMerchantTransferPathMerchantTab(merchantTabParams),
  });
};
export default useMerchantTabQuery;
